module.exports = __webpack_public_path__ + "media/images/app/benefits/price-c2639045898cccc32b9980112ac54918.webp";